import { Spacer } from "./Spacer";
import type { SpacerProps } from "./types";

export { Spacer, SpacerProps };
